<template>
  <div>
    <el-row class="main" type="flex" justify="space-between">
      <!-- 左侧列表 -->
      <el-col class="m-lr">
        <div class="top">
         <div>
          <img src="../../../assets/images/changeinfo.png" alt />
          <div>修改人员信息</div>
         </div>
        </div>
        <div class="bottom">
        <div>
        <img src="../../../assets/images/addinfo.png" alt />
          <div>添加人员信息</div>
        </div>
        </div>
      </el-col>
      <el-col></el-col>
    </el-row>
  </div>
</template>

<script>
import {findOrgTj} from "../../../api/http.js"
export default {
  created() {
    this.getquanbushuju()
  },
  methods:{
    // async  getquanbushuju(){
    //   let res=await findOrgTj()

    // },
  getquanbushuju(){
     this.$http.post(
      "/section/info/findOrgTj",

     )
  }
    // this.$http.post()
  }
};
</script>

<style lang="less" scoped>
.mapdiv {
  height: calc(91vh - 40px);
  width: 56vw;
}
.main {
  height: calc(91vh - 40px);

  .m-lr {
    height: calc(91vh - 40px);
    width: 22vw;
    background-color: #f2f9fd;
    .top {
      height: 50%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      img{
          margin-bottom: 20px;
      }
    }
    .bottom {
      height: 50%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
       img{
          margin-bottom: 20px;
      }
    }
  }
}
</style>